import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-airports.light.webp";
import imageDark from "../images/national-airports.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-airports",
  displayName: `National Airports`,
  datasetProductCode: `GEOSCAPE AIRPORTS`,
  subtitle: `Comprehensive Digital Dataset of Australian Airports`,
  shortDescription: `Airport is a digital representation of landing strips for Australia. This dataset provides an optimised aggregated national view of airport landing strip geometry and attribution. The dataset is created from multiple sources including jurisdictional data which is revised regularly and supplied in varying formats and at different levels of quality.
Airports is designed to meet the needs of organisations that require a graphical representation of locations of the landing strips (from local to international landing strips) to integrate with other data in servicing their business needs.`,
  metadata: {
    dateAdded: 1264982400000,
    dataType: ["Points", "Lines"],
    totalFeatureCount: 13081,
    updateFrequency: `As Deemed Necessary`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/airports.html`,
  productDescriptionLink: `https://geoscape.com.au/wp-content/uploads/2021/05/Airports-Product-Description.pdf`,
  imageLight,
  imageDark,
  searchTags: `National Airports Geoscape Airports Aviation Logistics Emergency Response Navigation`,
  detail: () => import("../details/national-airports").then((m) => m.detail),
};

export default entry;
